import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'product',
    serviceName: 'grapghql',
    query: gql`
      query product($ids: [String]) {
        product(ids: $ids) {
          data {
            id
            title
            media {
              id
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
